export { MerchandisingSmallBanner, MerchandisingSmallBannerComponent } from './MerchandisingSmallBanner';
export type { IMerchandisingSmallBannerProps } from './MerchandisingSmallBanner.types';
